import React, { useState } from "react";
import { useLang } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Mail } from "lucide-react";

export const SiteFooter = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <footer data-testid="site-footer" className="print:hidden border-t border-[var(--line)] bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
        <p className="text-[11px] text-ink-soft leading-relaxed">
          © 2026 Matambanadzo Studio · {t("Designed and Developed by Matambanadzo Studio")}
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 shrink-0">
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <button
                data-testid="footer-about-link"
                className="text-[11px] font-semibold text-vin hover:underline underline-offset-2"
              >
                {t("About the Project")}
              </button>
            </DialogTrigger>
            <DialogContent className="max-w-lg" data-testid="about-modal">
              <DialogHeader>
                <DialogTitle className="font-display text-xl text-ink">{t("About the Root Causes Challenge")}</DialogTitle>
              </DialogHeader>
              <div className="space-y-4 text-sm text-ink-soft leading-relaxed">
                <p>
                  {t("The Root Causes Challenge is an interactive poverty simulation designed for community advocacy, classrooms, civic workshops, faith communities, and policy trainings. Participants walk in the shoes of a neighbor facing impossible trade-offs — and discover the systemic barriers behind economic insecurity.")}
                </p>
                <p>
                  {t("It is designed and developed by Matambanadzo Studio, an independent civic-tech practice building formation tools that turn empathy into action.")}
                </p>
                <a
                  href="mailto:pam@matambanadzostudio.com"
                  data-testid="about-contact-link"
                  className="inline-flex items-center gap-2 bg-vin text-white font-semibold px-5 py-2.5 rounded-full hover:bg-vin-hover transition-colors duration-200"
                >
                  <Mail className="w-4 h-4" strokeWidth={1.75} />
                  {t("Inquiries & Partnerships")}
                </a>
                <p className="text-xs text-ink-soft">pam@matambanadzostudio.com</p>
              </div>
            </DialogContent>
          </Dialog>
          <a
            href="/terms"
            data-testid="footer-terms-link"
            className="text-[11px] font-semibold text-vin hover:underline underline-offset-2"
          >
            {t("Terms of Use")}
          </a>
          <a
            href="/privacy"
            data-testid="footer-privacy-link"
            className="text-[11px] font-semibold text-vin hover:underline underline-offset-2"
          >
            {t("Privacy Policy")}
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default SiteFooter;
